import React from "react";
import ImageFrame from "./Imageframe";
import { INTRO, IMAGES } from "./Gpmsdata";
 
const GPMSIntro = () => (
  <section className="gp-intro">
    <div className="gp-container gp-intro__grid">
      <div className="gp-intro__content">
        <p className="gp-intro__label">{INTRO.label}</p>
 
        <h2 className="gp-intro__title">
          {INTRO.title}
          <span>{INTRO.highlight}</span>
        </h2>
 
        {INTRO.paragraphs.map((p, i) => (
          <p key={i} className="gp-intro__text">
            {p}
          </p>
        ))}
      </div>
 
      <div className="gp-intro__media">
        <ImageFrame
          src={IMAGES.intro}
          alt="Container terminal gate with trucks queuing"
          size="lg"
        />
        <ul className="gp-chips">
          {INTRO.chips.map((chip) => (
            <li key={chip} className="gp-chip">
              <span aria-hidden="true">✓</span> {chip}
            </li>
          ))}
        </ul>
      </div>
    </div>
  </section>
);
 
export default GPMSIntro;